import { type TableQueryType } from '../store/schema/TableQuery';
import type FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import type TableView from '../store/schema/TableView';
import type MailFolderTableQuery from '../store/schema/MailFolderTableQuery';
import { getItem } from 'owa-local-storage';

type Pivot = 'n/a' | 'all' | 'focused' | 'other' | 'priority' | 'none';

export function getSelectedInboxPivot(tableView: TableView): Pivot {
    const folderName =
        tableView.tableQuery.type === 0 && folderIdToName(tableView.tableQuery.folderId);
    const focusedViewFilter = (tableView.tableQuery as MailFolderTableQuery).focusedViewFilter;
    let pivot: Pivot = 'n/a';
    if (folderName === 'inbox') {
        switch (focusedViewFilter) {
            case -1: {
                pivot = 'none';
                break;
            }
            case 0: {
                pivot = 'focused';
                break;
            }
            case 1: {
                pivot = 'other';
                break;
            }
        }
    }

    return pivot;
}

// Returns true if the current table is the High Priority filter and the user got
// there via the Prioritize rollup UI. Otherwise, returns false.
export function getPrioritizeRollupClickStatus(tableView: TableView): boolean {
    const isPriorityFilter =
        (tableView.tableQuery as MailFolderTableQuery).viewFilter === 'CopilotHighPriority';

    return isPriorityFilter && getItem(window, 'mail_prioritizeRollupFilter') === 'true';
}
